import { GROUPS } from '../ids';
import { InstallLocation } from '../types';
export const ids = GROUPS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    showInLoginMenu: true,
    showInMemberMenu: true,
    method: 'addSection',
    social: false,
    socialHome: false,
    menuOrder: 2,
    urlOverride: 'my-groups',
    page: {
        name: t('editor.groups-page.name'),
        shortDescription: t('editor.groups-page.short-description'),
        description: t('editor.groups-page.description'),
        iconURL: `${staticsUrl}/assets/images/icons/groups-icon.png`,
        origin: t('editor.groups-page.origin'),
        isNew: true,
        screenshots: [
            `${staticsUrl}/assets/images/groups/desk-groups.png`,
            `${staticsUrl}/assets/images/groups/desk-post.png`,
            `${staticsUrl}/assets/images/groups/mob-groups.png`,
            `${staticsUrl}/assets/images/groups/mob-post.png`,
        ],
    },
});
//# sourceMappingURL=groups.js.map